import {getLimitOrdersRequest} from "@/api/food-order";

export default {
    setLimitOrders({commit}, request = true) {
        if(request) {
            getLimitOrdersRequest()
                .then(res => {
                    commit('SET_LIMIT_ORDERS', res.data.orders);
                    commit('SET_VOUCHER_LIMITS', res.data.voucherLimits);
                });
        } else {
            commit('SET_LIMIT_ORDERS', []);
            commit('SET_VOUCHER_LIMITS', []);
        }
    },
};
